module.exports = __webpack_public_path__ + "static/media/search.67e284b5.svg";